import { DATA_DISPLAY_TYPES } from "@shared/components/table-implementation/bcl-table-data/data-display-type";
import { HEADER_DISPLAY_TYPES } from "@shared/components/table-implementation/bcl-table-data/header-display-type";
import { SORT_DIRECTIONS } from "@shared/components/table-implementation/types/sorting-directions";
import { TableConfig } from "@shared/components/table-implementation/types/table-config";
import { TableColumn } from "@shared/components/table-implementation/types/column/header.type";


const TABLE_TRANSLATION_SCOPE: string = "feature/project-customer-documents-overview";
const HEADERS: TableColumn[] = [
  {
    field: "id",
    dataFields: [ "type_number" ],
    isRequiredField: true,
    translationInfo: {
      defaultText: "Nummer",
      token: "table-column-number",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.string,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: false, widthPx: 150 }
  },
  {
    field: "name",
    dataFields: [ "type_name" ],
    translationInfo: {
      defaultText: "Dokument",
      token: "table-column-name",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.string,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: true, widthPx: 365 }
  },
  {
    field: "duration",
    dataFields: [ "type_validityUnit_name", "type_validityDuration" ],
    translationInfo: {
      defaultText: "Gültigkeit",
      token: "table-column-validity",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.duration,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: true, widthPx: 150 }
  },
  {
    field: "description",
    dataFields: [ "type_defaultDescription" ],
    translationInfo: {
      defaultText: "Anmerkung",
      token: "table-column-note",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.string,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: true, widthPx: 520 }
  },
  {
    field: "edit",
    translationInfo: {
      defaultText: "Bearbeiten",
      token: "table-column-edit",
      scope: TABLE_TRANSLATION_SCOPE
    },
    headerDisplayType: HEADER_DISPLAY_TYPES.string,
    dataDisplayType: DATA_DISPLAY_TYPES.edit,
    options: { sortDirection: SORT_DIRECTIONS.NO_SORT, isVisible: true, widthPx: 120 }
  }
];

export const PROJECT_SPECIAL_TIMES_TABLE_CONFIG: TableConfig = {
  id: crypto.randomUUID(),
  isDefault: true,
  name: "Standardconfig",
  columnConfig: {
    columns: HEADERS,
    fieldsSortedByOptions: []
  }
};
